import React, { useState } from 'react';
import { useSelector } from 'react-redux';

import {
  selectAuthFeatureFlags,
  selectAuthPermissions,
  selectHasAnySubscription,
  selectUseSnapshotsUI,
} from '../../../../auth/AuthSelectors';
import { getSearchUrl } from '../../../../shared-components/Shared/SearchUtils';
import { searchOrigins } from '../../../Navigation/constants';
import { SearchFilterContentTypes } from '../../../Shared/enums';
import { SearchOption } from '../../../Shared/types';
import { selectIsEnterpriseMember } from '../../selectors/searchSelectors';
import { fetchTypeahead } from '../../utils/searchUtils';
import ProminentSearchNav from './ProminentSearchNav';

interface ProminentSearchContainerProps {
  imagesUrl: string;
  contentTypes: SearchOption[];
  contentType: SearchFilterContentTypes;
  setContentType: (newContentType: SearchFilterContentTypes) => void;
  showDropdown?: boolean;
  showContentToggles?: boolean;
  isLanding?: boolean;
}

const ProminentSearchContainer = ({
  imagesUrl,
  contentTypes,
  contentType,
  setContentType,
  showDropdown = true,
  showContentToggles,
  isLanding = false,
}: ProminentSearchContainerProps) => {
  const [showSuggestions, setShowSuggestions] = useState(false);
  const handleSubmit = (contentType: string, searchTerm: string) => {
    const searchUrl = getSearchUrl({
      contentType: contentType as SearchFilterContentTypes,
      searchTerm,
      searchOrigin: searchOrigins.SEARCH_BAR,
    });
    window.location.href = searchUrl;
  };

  const userHasAnySubscription = useSelector(selectHasAnySubscription);
  const isEnterpriseMember = useSelector(selectIsEnterpriseMember);
  const { pproPluginEnabled } = useSelector(selectAuthPermissions);
  const useSnapshotsUI = useSelector(selectUseSnapshotsUI);
  const { showConversationalSearch } = useSelector(selectAuthFeatureFlags);

  return (
    <ProminentSearchNav
      contentType={contentType}
      onDropdownChange={(contentType) => {
        setContentType(contentType as SearchFilterContentTypes);
      }}
      onSubmit={handleSubmit}
      searchTerm={''}
      userHasAnySubscription={userHasAnySubscription}
      fetchTypeahead={fetchTypeahead}
      isEnterpriseMember={isEnterpriseMember}
      pproPluginEnabled={pproPluginEnabled}
      isSearchAppLoaded={() => false}
      imagesUrl={imagesUrl}
      prominentSearchOptions={contentTypes}
      contentTypeFromPrevious={
        contentType || SearchFilterContentTypes.All_videos_content_type
      }
      showDropDown={showDropdown}
      showContentToggles={showContentToggles}
      setShowSuggestions={setShowSuggestions}
      showSuggestions={showSuggestions}
      useSnapshots={useSnapshotsUI}
      showConversationalSearchCta={showConversationalSearch}
      isLanding={isLanding}
    />
  );
};

export default ProminentSearchContainer;
